import { ProcurementViewModel } from "./ProcurementView.model";

export class ProcurementView extends ProcurementViewModel {
    // Add custom methods here
}
